import { render, staticRenderFns } from "./tbmDetail.vue?vue&type=template&id=28b65d48"
import script from "./tbmDetail.vue?vue&type=script&lang=js"
export * from "./tbmDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28b65d48')) {
      api.createRecord('28b65d48', component.options)
    } else {
      api.reload('28b65d48', component.options)
    }
    module.hot.accept("./tbmDetail.vue?vue&type=template&id=28b65d48", function () {
      api.rerender('28b65d48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/demo/tbmDetail.vue"
export default component.exports